import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import RemoveRedEyeOutlined from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineOutlined from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlined from "@mui/icons-material/EditOutlined";

import { useDispatch, useSelector } from "react-redux";
import {
  openDeleteModal,
  viewTransaction,
} from "../../../feature/transaction/transactionSlice";
import TransactionModals from "./TransactionModals";
// import { useState } from "react";

export default function TransactionTableRow(props) {
  //   const [select, setSelect] = useState("");
  const { mode } = useSelector((state) => state.mode);
  const dispatch = useDispatch();

  //   const handleChange = (event) => {
  //     console.log(event.target.value);
  //     setSelect(event.target.value);
  //   };

  return (
    <>
      {props?.row?.map((row) => (
        <TableRow key={row.id}>
          <TableCell component='th' scope='row'>
            {row.id}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.email}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.transaction}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.order}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.amount}
          </TableCell>
          <TableCell component='th' scope='row'>
            <Tooltip title='Edit'>
              <IconButton
                aria-label='edit'
                sx={{
                  "&:hover": {
                    color: "#3366ff",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
              >
                <EditOutlined />
              </IconButton>
            </Tooltip>
            <Tooltip title='View'>
              <IconButton
                aria-label='view'
                sx={{
                  "&:hover": {
                    color: "#3366ff",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
                onClick={() => dispatch(viewTransaction(row))}
              >
                <RemoveRedEyeOutlined />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete'>
              <IconButton
                aria-label='delete'
                sx={{
                  "&:hover": {
                    color: "#F24C4C",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
                onClick={() => dispatch(openDeleteModal(row))}
              >
                <DeleteOutlineOutlined />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      ))}

      <TransactionModals />
    </>
  );
}
